<template>
  <div class="sort-mobile">
    <div
      v-for="option in data.sortOptions"
      :key="option.id"
      :class="{ 'sort-mobile--active': data.activeOption === option.id }"
      class="sort-mobile__item"
      @click="emitSortOption(option.id)">
      {{ option.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSortMobile',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    emitSortOption(id) {
      this.$vuedals.close({ id });
    },
  },
};
</script>

<style lang="scss" scoped>
  .sort-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sort-mobile__item {
    padding-left: 20px;
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: $text-15px;
    color: $color--basic-dark-gray;
    border: 1px solid $color--basic-dark-gray;
    border-radius: 5px;
    transition: var(--transition-color-time) var(--transition-color-easing);
    transition-property: color, background-color, border-color;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 11px;
    }

    &:active {
      color: $color--basic-white;
      background-color: $color--basic-blue;
      border-color: $color--basic-blue;
    }
  }

  .sort-mobile--active {
    color: $color--basic-white;
    background-color: $color--basic-blue;
    border-color: $color--basic-blue;
  }
</style>
